export default function Logo({ dark = false, className = "" }) {
  if (dark) {
    return (
      <div className={`flex items-center gap-2.5 ${className}`} data-testid="dishly-logo">
        <img src="/dishly-icon.png" alt="Dishly" className="h-8 w-8" />
        <span className="font-display text-[22px] font-bold tracking-tight text-cream">Dishly</span>
      </div>
    );
  }
  return (
    <img
      src="/dishly-logo.png"
      alt="Dishly"
      className={`h-8 w-auto ${className}`}
      data-testid="dishly-logo"
    />
  );
}
